import { useLocalStorage } from 'usehooks-ts';
import { localStorageKeys } from '../lib/localstorageKeys';

export const fundingDisplayModes = ['1h', '8h', '1d', '1y'] as const;
export type FundingDisplayMode = (typeof fundingDisplayModes)[number];

export const useFundingDisplay = () => {
  const [fundingDisplayMode, setFundingDisplayMode] = useLocalStorage<FundingDisplayMode>(
    localStorageKeys.fundingDisplayMode,
    '1h'
  );

  return {
    fundingDisplayMode,
    setFundingDisplayMode,
  };
};
